import styled from 'styled-components';
import { Colors } from '@prezi/dragon';

export default styled.div<{ isOpen: boolean; isFixed: boolean }>`
    position: ${props => (props.isFixed ? 'fixed' : 'absolute')};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${Colors.gray1};
    transition: opacity 0.2s;
    opacity: ${({ isOpen }) => (isOpen ? '0.8' : '0')};
`;
